import { Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import config from 'config';

import { Layout } from './Components/Layout';

export const School = ({ send }: StepComponentProps) => (
  <Layout title="School that is not a 501(c)(3)" send={send}>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Public, private, charter schools or colleges
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      Our platform is designed for schools that meet specific eligibility criteria. Please review
      the following guidelines to ensure your institution qualifies to use the platform:
    </Typography>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Eligible Schools
    </Typography>

    <ul style={{ paddingLeft: 12 }}>
      <li>
        <Typography fontSize={15} lineHeight="38px" mb={2}>
          <strong>Public, Private, Charter Schools, or Colleges:</strong> Only institutions that
          fall under these categories and meet the necessary registration requirements can use our
          platform.
        </Typography>
      </li>
    </ul>

    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Qualification Criteria
    </Typography>

    <ul style={{ paddingLeft: 12 }}>
      <li>
        <Typography fontSize={15} lineHeight="38px" mb={2}>
          <strong>NCES-Registered Schools</strong>: If your school is registered with the National
          Center for Education Statistics (NCES), you are eligible to use the platform. If your
          institution qualifies but you cannot find it during the onboarding process, please{' '}
          <a
            href={`mailto:${config.nonprofitSuccessTeamEmail}`}
            style={{ textDecoration: 'underline' }}
          >
            contact support
          </a>
          for assistance.
        </Typography>
      </li>
      <li>
        <Typography fontSize={15} lineHeight="38px" mb={2}>
          <strong>501(c)(3) Schools</strong>: Schools that are registered as 501(c)(3) nonprofit
          organizations are also eligible to use the platform. If this applies to your school, you
          will need to{' '}
          <a
            target="_blank"
            href="https://www.paypal.com/us/webapps/mpp/givingfund/joinppgf"
            style={{ textDecoration: 'underline' }}
          >
            enroll in the PayPal Giving Fund (PPGF)
          </a>{' '}
          to proceed with the registration.
        </Typography>
      </li>
      <li>
        <Typography fontSize={15} lineHeight="38px" mb={2}>
          <strong>Need Assistance?</strong> If you&apos;re having trouble finding your
          NCES-registered school or have any other questions, feel free to{' '}
          <a
            href={`mailto:${config.nonprofitSuccessTeamEmail}`}
            style={{ textDecoration: 'underline' }}
          >
            reach out to our support team
          </a>
          .
        </Typography>
      </li>
    </ul>
  </Layout>
);
